import { parseISO, isToday as dateFnIsToday } from 'date-fns'

export const MedicalEstablishedVisits = ['video', 'focused']

export const isToday = (appointment: { start: string }) => {
  return dateFnIsToday(parseISO(appointment.start))
}

export const getDateTime = (date: Date, now: Date) => {
  if (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  ) {
    return new Date()
  } else {
    return date
  }
}
